import * as React from 'react';

import { IVacancy } from '../../index';
import { PreloaderWrapper } from '../preloader_wrapper/preloader_wrapper';
import { VacancyForm } from '../vacancy_form/vacancy_form';

import * as styles from './update_vacancy.css';
import { IHttpApi } from '@cian/http-api/shared';
import { IUser } from '../../types/user';
import { updateVacancy } from '../../services/updateVacancy';
import { ESubdomain } from '../../constants/domain';
import { ILogger } from '@cian/logger';
import { IRegion } from '../../types/region';

interface IUpdateVacancyProps {
  httpApi: IHttpApi;
  logger: ILogger;
  recaptchaSitekey: string;
  editBackUrl: string;
  regions: IRegion[];
  vacancy: IVacancy;
  user: IUser;
  useRecaptcha?: boolean;
}

interface IAddVacancyState {
  updateVacancyProcessing: boolean;
  isPublishError: boolean;
}

export class UpdateVacancy extends React.Component<IUpdateVacancyProps, IAddVacancyState> {
  public constructor(props: IUpdateVacancyProps) {
    super(props);

    this.state = {
      isPublishError: false,
      updateVacancyProcessing: false,
    };
  }

  public render() {
    return (
      <div className={styles['panel']}>
        <VacancyForm
          title="Редактировать вакансию"
          regions={this.props.regions}
          vacancy={this.props.vacancy}
          user={this.props.user}
          useRecaptcha={this.props.useRecaptcha}
          onSubmit={this.updateVacancy}
          recaptchaSitekey={this.props.recaptchaSitekey}
          isPublishError={this.state.isPublishError}
        />
        {this.state.updateVacancyProcessing && <PreloaderWrapper size={40} />}
      </div>
    );
  }

  private showProcessing() {
    this.setState({ updateVacancyProcessing: true });
  }

  private hideProcessing() {
    this.setState({ updateVacancyProcessing: false });
  }

  private updateVacancy = (vacancy: IVacancy, recaptcha: string) => {
    const { httpApi, logger } = this.props;

    this.showProcessing();
    updateVacancy({ httpApi, logger, subdomain: ESubdomain.UpdateVacancy }, { vacancy, recaptcha })
      .then(() => (window.location.href = `${this.props.editBackUrl}#${vacancy.id}`))
      .catch(() => {
        this.hideProcessing();
        this.setState({ isPublishError: true });
      });
  };
}
